import React from 'react';

const Achievements = () => {
  const achievements = [
    {
      title: "TikTok Tech Jam 2024",
      description: "4th place and People's Choice winner in Australia across 4484 participants globally in TikTok’s hackathon for building TikPlayLive",
      link: "https://devpost.com/software/mmcandco",
    },
    {
      title: "Susquehanna International Group Algothon 2024",
      description: "2nd place across 600+ participants in Australia and New Zealand. Developed an algorithm to trade 50+ stocks across 1000+ days. Achieved a score of 609.35 based on PnL and volatility where the average of all teams was 279 and average outside of top 3 was 22",
      link: "/algothon",
    },
    {
      title: "UNSW DevSoc HackaByte 2025",
      description: "Best UI/UX award across 86 participants for building an AI integrated course forum",
      link: "https://devpost.com/software/edbutbetter",
    },
    {
      title: "SYNCHack 2024",
      description: "Awarded “Best Pitch” for presentation in University of Sydney’s flagship hackathon from 46 teams for developing an app connecting users during Protests",
      link: "https://devpost.com/software/rallynow",
    },
    {
      title: "2024 DevSoc Blueprint Hackathon",
      description: "“Special Mention” in UNSW Software Dev Society's Hackathon for developing a personalized leetcode platform geared towards students from AU",
      link: "https://devpost.com/software/test-4i3b9q",
    },
    {
      title: "CalHacks Hack Month 2023",
      description: "Achieved 2nd place in UC Berkeley’s sustainability focused Hackathon for developing an iOS app to gamify sustainable habits",
      link: "https://www.instagram.com/p/Cup1sIMovwo/?igshid=MzRlODBiNWFlZA%3D%3D&img_index=3",
    },
  ];

  return (
    <section style={styles.container}>
      <h2 style={styles.heading}>Highlights</h2>
      <ul style={styles.list}>
        {achievements.map((achievement, index) => (
          <li key={index} style={styles.item}>
            <a
              href={achievement.link}
              target={achievement.link.startsWith("http") ? "_blank" : "_self"} // Open external links in a new tab
              rel="noopener noreferrer"
              style={styles.link}
            >
              <strong>{achievement.title} </strong>
            </a>
             – {achievement.description}
          </li>
        ))}
      </ul>
    </section>
  );
};

const styles = {
  container: {
    padding: '0px 10px',
  },
  heading: {
    fontSize: '1.8rem',
    marginBottom: '20px',
    textAlign: 'center',
  },
  list: {
    listStyleType: 'none',
    padding: 0,
    lineHeight: '1.8',
  },
  item: {
    fontSize: '1rem',
    marginBottom: '10px',
  },
  link: {
    color: '#007BFF',
    textDecoration: 'none',
  },
};

export default Achievements;
